module.exports = __webpack_public_path__ + "static/media/aboutMeImageMobile.017eef31.jpg";